export default __webpack_public_path__ + "static/media/logo.a6e9f20d.png";